import { createSvgComponent } from "../../icon/createSvgComponent";
import Flash1Fill from "@core/icon/assets/flash-1-fill.svg";
export default createSvgComponent(Flash1Fill);